export default "__VITE_ASSET__CqND0oSr__"